import React from 'react';
import styles from './CreateParentAccount.module.css';
import { CreateParentAccountElement } from '../CreateParentAccountElement';

export const DesktopView = (): JSX.Element => {
  // Redux Hooks

  const createAccountElement = CreateParentAccountElement();
  return (
    <React.Fragment>
      <div className={styles.createParentAccountDesktop}>
        <section
          className={styles.createAccountMainSection}
          id="create-account-main-section"
        >
          <img
            className={styles.desktopHeaderIcon}
            id="desktop-header"
            alt=""
            src="assets/common/bba-logo.svg"
          />
          <div className={styles.progressIndicatorDiv}>
            <img
              className={styles.desktopProgressIndicator1Icon}
              id="desktop-progress-indicator-1"
              alt=""
              src="assets/common/desktop-progress-indicator-1.svg"
            />
          </div>
          <section
            className={styles.createAccountMainGroupSection}
            id="create-account-main-group"
          >
            <section
              className={styles.createAccountMainGroupContSection}
              id="create-account-main-group-content-group"
            >
              {/* <section
                  className={styles.createAccountMainGroupContSection1}
                  id="create-account-main-group-content-social-login-group"
                >
                  <img
                    className={styles.createAccountMainGroupContIcon}
                    id="create-account-main-group-content-social-login-facebook"
                    alt=""
                    src="assets/common/facebook-icon.svg"
                  />
                  <img
                    className={styles.createAccountMainGroupContIcon1}
                    id="create-account-main-group-content-social-login-apple"
                    alt=""
                    src="assets/common/apple-icon.svg"
                  />
                  <img
                    className={styles.createAccountMainGroupContIcon2}
                    id="create-account-main-group-content-social-login-google"
                    alt=""
                    src="assets/common/google-icon.svg"
                  />
                  <div className={styles.createAccountMainGroupContDiv}>
                    or continue with Social Media
                  </div>
                </section> */}

              <div className={styles.createAccountTitleDiv}>
                Create Parent Profile
              </div>
              <div className={styles.createAccountMainGroupContTextField}>
                {createAccountElement.emailInput}
              </div>
              <div className={styles.createAccountMainGroupContDiv1}>
                Big Bang Academy uses the email address as the primary way to
                communicate with you.
              </div>
              <section
                className={styles.createAccountLoginButtonGrSection}
                id="create-account-login-button-group"
              >
                <button
                  className={styles.createAccountLoginButton}
                  id="create-account-login-button"
                  onClick={createAccountElement.loginRedirectButtonClickHandler}
                >
                  <span
                    className={styles.createAccountLoginButtonTeSpan}
                    id="create-account-login-button-text"
                  >
                    Already have an account?
                  </span>
                  <span className={styles.loginSpan}>Login</span>
                  <span className={styles.span}>.</span>
                </button>
              </section>
              <div
                className={styles.createAccountMainGroupContButton}
                id="create-account-main-group-content-next-button"
              >
                {createAccountElement.continueButton}
              </div>
            </section>
            <div className={styles.createAccountMainGroupPartDiv}>
              <a
                className={styles.createAccountMainGroupPart1}
                id="create-account-main-group-partership"
              >{`Click`}</a>
              <a
                className={styles.createAccountMainGroupPart2}
                id="create-account-main-group-partership"
              >
                here
              </a>
              <a
                className={styles.createAccountMainGroupPart}
                id="create-account-main-group-partership"
              >
                if you are a teacher / business partner.
              </a>
            </div>
          </section>
        </section>
        <section
          className={styles.desktopRightSideSection}
          id="desktop-right-side-section"
        >
          <img
            className={styles.desktopBgIcon}
            id="desktop-bg"
            alt=""
            src="assets/common/desktop-bg@3x.png"
          />
          <img
            className={styles.createAccountImageIcon}
            id="create-account-image"
            alt=""
            src="assets/createParentAccount/create-account-image@3x.png"
          />
        </section>
      </div>
    </React.Fragment>
  );
};
